import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import translate from "i18n/translate";
import { copyToClipboard } from "utils";
import ApplicationCard from "./ApplicationCard";
import CheckIcon from "./icons/CheckIcon";

const ApplicationKey = ({ secretKey, title }) => (
  <Grid container justifyContent="center">
    {title ? (
      <Grid item xs={12}>
        <Typography
          variant="h5"
          style={{ textAlign: "center", marginBottom: "20px" }}
        >
          {title}
        </Typography>
      </Grid>
    ) : (
      <Grid
        as="div"
        item
        container
        direction="column"
        alignContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <CheckIcon />
        </Grid>
        <Grid item>
          <Box as="div" mb={2}>
            <Typography>Aplicacion creada</Typography>
          </Box>
        </Grid>
      </Grid>
    )}
    <Grid item xs={12}>
      <ApplicationCard
        name={translate("applications.secretPass")}
        appKey={secretKey}
        action="common.copy"
        actionToExecute={(text) => copyToClipboard(text)}
      />
    </Grid>
  </Grid>
);

export default ApplicationKey;
